import React from "react";

const Product = () =>{
    return(
    <>
    <div id="services">
    <div className="container">
      <div className="row d-flex align-items-center">
        <div className="col-lg-12">
          <div className="mb-30px">
            <div className="section-heading theme-text-center">
              <h1 className="head-back-light">Awesome Services</h1>
              <h2 className="head-after">Our Services</h2>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="service-item">
            <div className="card">
              <div className="service-count-text">
                <span>01</span>
              </div>
              <div className="service-icon">
              <i class="fa-solid fa-cake-candles"></i>
              </div>
              <h4>Event Planning</h4>
              <p>
              A blend of professionalism, creativity, and passion, conveying the 
              planner's dedication to crafting exceptional events that leave a lasting impression.
              </p>
              <a href="#lu" className="btn btn-icon">
                <span>Read More</span>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="service-item">
            <div className="card">
              <div className="service-count-text">
                <span>02</span>
              </div>
              <div className="service-icon">
              <i class="fa-solid fa-truck"></i>
              </div>
              <h4>Logistics</h4>
              <p>
              A blend of professionalism, expertise, and innovation, conveying the company's commitment 
              to delivering unparalleled logistics solutions that empower businesses to thrive.
              </p>
              <a href="#lu" className="btn btn-icon">
                <span>Read More</span>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="service-item">
            <div className="card">
              <div className="service-count-text">
                <span>03</span>
              </div>
              <div className="service-icon">
              <i class="fa-solid fa-utensils"></i>
              </div>
              <h4>Food</h4>
              <p>
              A blend of culinary expertise, creativity, and passion, conveying the caterer's commitment to
               crafting exceptional dining experiences that leave guests craving more.
              </p>
              <a href="#lu" className="btn btn-icon">
                <span>Read More</span>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="service-item">
            <div className="card">
              <div className="service-count-text">
                <span>04</span>
              </div>
              <div className="service-icon">
              <i class="fa-solid fa-house-chimney-crack"></i>
              </div>
              <h4>Insurance</h4>
              <p>
              We believe that insurance should be more than just a transaction. 
              It's a commitment to protecting your future and giving you peace of mind.
              </p>
              <a href="service-single.html" className="btn btn-icon">
                <span>Read More</span>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="service-item">
            <div className="card">
              <div className="service-count-text">
                <span>05</span>
              </div>
              <div className="service-icon">
              <i class="fa-solid fa-car-tunnel"></i>
              </div>
              <h4>Auto Parts</h4>
              <p>
              We are committed to providing our customers with the best possible service and products.
               We are constantly striving to improve our offerings and exceed your expectations.
              </p>
              <a href="#lu" className="btn btn-icon">
                <span>Read More</span>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="service-item">
            <div className="card">
              <div className="service-count-text">
                <span>06</span>
              </div>
              <div className="service-icon">
              <i class="fa-solid fa-chair"></i>
              </div>
              <h4>Rentals</h4>
              <p>
                We rent chairs, tables, sound systems etc for events. 
                We are constantly striving to improve our offerings and exceed your expectations.
              </p>
              <a href="#lu" className="btn btn-icon">
                <span>Read More</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
    )
}

export default Product;